import BulkTagModal from "../components/Tagging/BulkTagModal";
import React from 'react';
import withModals from "./withModals";
import {compose} from "redux";
import {connect} from "react-redux";
import {tags} from "../ducks";

/**
 * This is an HOC that adds tagging helper functionality to a component.
 *
 * Injects the following props:
 *   addTags: function to bulk add tags
 *   removeTags: function to bulk remove tags
 *   reloadTags: function that will mark tags as dirty; used when saving an object may modify the available tags
 *
 * Also Includes a <ModalRoot/> with the BulkTagModal used for bulk add/remove tags.
 *
 * @example use withTagging
 *   const mapDucksToPros = () => ({entity, tags});
 *   export default compose(
 *     withFiltering,
 *     withTagging(entity)
 *     duckify(mapDucksToProps),
 *   )(MyComponent);
 *
 * @example usage of addTags and removeTags
 *   <BulkTagAction onSubmit={selectedTags => addTags(selectedEntities, selectedTags)} tags={tags}/>
 *   <BulkUntagAction onSubmit={selectedTags => removeTags(selectedEntities, selectedTags)} tags={tags}/>
 *
 * @example usage of reloadTags
 *   <Button onClick={() => save(myObject).then(reloadTags)}>Save</Button>
 *
 * @param {Object} taggableDuck the duck entity
 */
const withTagging = (taggableDuck) => (Component) => {

  const mapDispatchToProps = (dispatch) => ({
    addTags: (taggables, tagNames) => dispatch(taggableDuck.actions.tag(taggables.map(t => t.id), tagNames))
      .then(() => dispatch(taggableDuck.actions.markDirty()))
      .then(() => dispatch(tags.actions.markDirty())),

    removeTags: (taggables, tagNames) => dispatch(taggableDuck.actions.untag(taggables.map(t => t.id), tagNames))
      .then(() => dispatch(taggableDuck.actions.markDirty()))
      .then(() => dispatch(tags.actions.markDirty())),

    reloadTags: () => dispatch(tags.actions.markDirty())
  });

  return compose(
    withModals({BulkTagModal}),
    connect(null, mapDispatchToProps)
  )(Component);
};

export default withTagging;
